import { render, staticRenderFns } from "./MataKuliah.vue?vue&type=template&id=2c1d72b6&scoped=true&"
import script from "./MataKuliah.vue?vue&type=script&lang=js&"
export * from "./MataKuliah.vue?vue&type=script&lang=js&"
import style0 from "./MataKuliah.vue?vue&type=style&index=0&id=2c1d72b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1d72b6",
  null
  
)

export default component.exports